<template>
  <div class="login-form">
    <div class="login-form-div">
      <h1>{{ title }}</h1>
      <slot name="content"></slot>
      <div class="login-form-links">
        <slot name="links"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'login-box',
  props: {
    title: {
      type: String,
      required: true,
    },
  }
}
</script>

<style lang="scss">
.login-form {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 100px;
  .login-form-div {
    background-color: #333;
    padding: 30px 50px 50px 50px;
    width: 370px;
    border-radius: 3px;
    h1 {
      font-weight: 100;
      font-size: 35px;
      margin-bottom: 20px;
      color: #666;
    }
    .check {
      color: #ff6d6d;
      margin-bottom: 20px;
      a {
          color: white;
      }
    }
    .success {
      color: #85ff6d;
      margin-bottom: 20px;
      a {
          color: white;
      }
    }
    label,
    input {
      display: block;
    }
    label {
      color: #eee;
      margin-left: 5px;
      margin-bottom: 3px;
    }
    input {
      border: 1px solid #666;
      box-sizing: border-box;
      width: 100%;
      padding: 10px 7px;
      color: #fff;
      border-radius: 3px;
    }
    button {
      background-color: #FFC20E;
      color: #000;
      width: 100%;
      padding: 10px 0;
      font-weight: 600;
    }
  }
  .login-form-links {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #444;
    a {
      color: white;
    }
  }
}
</style>
